import { render } from "./FormContainer.vue?vue&type=template&id=d8389656&scoped=true&ts=true"
import script from "./FormContainer.vue?vue&type=script&lang=ts"
export * from "./FormContainer.vue?vue&type=script&lang=ts"

import "./FormContainer.vue?vue&type=style&index=0&id=d8389656&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8389656"]])

export default __exports__